import ApiService from './ApiService'

const ROOT_URL = '/services/onboarding/api/otp/private';

const OtpApi = new ApiService(ROOT_URL, '', {
  send: function (ctx, processId, leadPartyId, onSuccess, onError) {
    this.apiGET(ctx, '/sendOtp?processId=' + processId + '&leadId=' + leadPartyId, onSuccess, onError);
  }
});

export default OtpApi;



// WEBPACK FOOTER //
// ./src/service/OtpService.js